















































































import {Component, Mixins} from 'vue-property-decorator'
import Navbar from '@/components/navbar/Navbar.vue'
import NetworkStatsView from '@/views/home/NetworkStatsView.vue'
import GasbotHeader from '@/components/gasbot/GasbotHeader.vue'
import GasbotAbout from '@/components/gasbot/GasbotAbout.vue'
import LatestNewsView from '@/views/home/LatestNewsView.vue'
import BannerList from '@/components/lists/BannerList.vue'
import AppFooter from '@/components/footer/AppFooter.vue'
import {MetaInfo} from 'vue-meta'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import GasCalculatorView from '@/views/home/GasCalculatorView.vue'
import TokenNftView from '@/views/home/TokenNftView.vue'
import OrbitHomeView from '@/views/OrbitHomeView.vue'
import NetworkModeAlert from '@/components/NetworkModeAlert.vue'
import {NetworkModeHelper} from '@/helpers/NetworkModeHelper'

@Component({
  components: {
    OrbitHomeView,
    GasCalculatorView,
    Navbar,
    NetworkModeAlert,
    NetworkStatsView,
    GasbotHeader,
    GasbotAbout,
    LatestNewsView,
    BannerList,
    AppFooter,
    TokenNftView,
  },
})
export default class HomeView extends Mixins(MixinScreenSize) {
  get isOrbitEnabled(): boolean {
    return this.$auth?.global?.isOrbitFeatureActive !== false
  }

  get isTestnet(): boolean {
    return NetworkModeHelper.isTestnet()
  }

  metaInfo(): MetaInfo {
    return {
      title: this.$translate('metadata.title.home'),
    }
  }

  titleFontSize() {
    return 'text-5xl xs:text-title'
  }
}
